//libs
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';

//styles
import { Container, SortContainer } from './styles';

//components
import AppliedFiltersV2 from 'shared/components/AppliedFiltersV2';
import SortFilterWrapper from 'shared/components/Filter/SortFilter';

//helpers
import { removeSingleFilter } from './helpers';
import { onFiltersUpdated } from 'shared/layouts/Listing/Desktop/components/AnalyticsV2/helpers';

//constants
import { SORT_FILTERS_GAP } from './constants';
import { SORT_CONTAINER_WIDTH } from 'shared/layouts/Listing/Desktop/components/Layout/constants';

//hooks
import { useFilters } from 'shared/store/listingV2/hooks';
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

//selectors
import { getAppliedFilters } from 'shared/store/listingV2/selectors';

//types
interface IAppliedFiltersAndSort {
  isFiltersExpanded: boolean;
  setIsFiltersExpanded: (state: boolean) => void;
  isSticky: boolean;
}

function AppliedFiltersAndSort({
  isFiltersExpanded,
  setIsFiltersExpanded,
  isSticky,
}: IAppliedFiltersAndSort) {
  const { updateAppliedFilter } = useFilters();
  const { deviceWidth } = useResponsiveContext();
  const container = useRef();
  const [isExpandedAndNotScrolled, setIsExpandedAndNotScrolled] = useState(true);
  const appliedFilters = useSelector(getAppliedFilters);

  const appliedFilterRemoved = useCallback(
    (key, id) => {
      updateAppliedFilter(removeSingleFilter(key, id, appliedFilters));
      onFiltersUpdated();
    },
    [appliedFilters, updateAppliedFilter]
  );

  const appliedFiltersWidth = useMemo(() => {
    let filtersWidth = deviceWidth / 2;
    if (!isEmpty(appliedFilters)) {
      if (container.current) {
        filtersWidth = container.current.scrollWidth - SORT_CONTAINER_WIDTH;
      }
    }
    filtersWidth = filtersWidth - SORT_FILTERS_GAP;

    return filtersWidth;
  }, [appliedFilters, deviceWidth]);
  useEffect(() => {
    if (isFiltersExpanded && !isSticky) {
      setIsExpandedAndNotScrolled(true);
    } else {
      setIsExpandedAndNotScrolled(false);
    }
  }, [isFiltersExpanded, isSticky]);

  return (
    <Container ref={container} isFiltersExpanded={isExpandedAndNotScrolled}>
      <AppliedFiltersV2
        isFiltersExpanded={isFiltersExpanded}
        setIsFiltersExpanded={setIsFiltersExpanded}
        onFilterRemove={appliedFilterRemoved}
        filtersWidth={appliedFiltersWidth}
      />
      <SortContainer isFiltersExpanded={isExpandedAndNotScrolled} isSticky={isSticky}>
        <SortFilterWrapper />
      </SortContainer>
    </Container>
  );
}
export default memo(AppliedFiltersAndSort);
